// extracted by mini-css-extract-plugin
module.exports = {"bgBlur":"Navbar_bgBlur__fr22K"};